import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { GlobalService } from '../services/global.service';

export const clientAreaGuard: CanActivateFn = (_route, state) => {
  const authService = inject(AuthService);
  const globalService = inject(GlobalService);
  const router = inject(Router);
  const user = globalService.loggedUserClass;

  if (!authService.isLoggedin(user)) {
    if (state.url && state.url.includes('participar-sinistro')) {
      const parsedUrl = router.parseUrl(state.url);
      router.navigate(['/participar-sinistro'], {
        queryParams: parsedUrl.queryParams,
      });
      return false;
    }
    router.navigate(['/login']);
    return false;
  }

  if (user?.Admin || user?.ClientArea || user?.CommercialArea || user?.IntermediaryArea) {
    return true;
  }

  router.navigate(['/home']);
  return false;
};
